import React, { ReactElement, useEffect, useRef, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';

export const Cell = ({ props,isArray }: { props: any,isArray?: any }): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;
      if (props?.field === 'accommodation' && props?.row?.accommodation_color) {
        parentElement.style.background = props?.row?.accommodation_color;
      }

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  // TODO: this uses a lot of memory
  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (divWidth['element'] > divWidth['cell']) {
      setTooltip(true);
    }
  });

  const checkForOverflow = () => {
    if (divRef.current) {
      const element: any = divRef.current;
      return element.scrollWidth > element.clientWidth;
    }
    return false;
  };

  useEffect(() => {
    setTooltip(checkForOverflow());
  });

  return (
    <div ref={divRef} className={`whitespace-nowrap truncate`}>
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={
              typeof props?.value === 'object' && props?.value !== null
                ? '-----'
                : props?.value
            }
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <span>
              {typeof props?.value === 'object' && props?.value !== null
                ? '-----'
                : props?.value}
            </span>
          </Tooltip>
        </>
      ) : (
        <>
          {typeof props?.value === 'object' && props?.value !== null
            ? '-'
            : props?.value}
        </>
      )}
    </div>
  );
};
